import Vue from "vue";
import ConfirmDialog from "@/components/xcoins/ConfirmDialog.vue";

let confirmVm = null;

/** 单例挂到 body，供积分商城各处 this.$xcoinsConfirm 调用 */
function getConfirmVm(app) {
  if (confirmVm) {
    return confirmVm;
  }
  const ConfirmCtor = Vue.extend(ConfirmDialog);
  confirmVm = new ConfirmCtor({
    i18n: app.i18n,
  });
  confirmVm.$mount();
  document.body.appendChild(confirmVm.$el);
  return confirmVm;
}

export default function ({ app }, inject) {
  if (!process.client) {
    inject("xcoinsConfirm", () => Promise.reject("cancel"));
    return;
  }

  /**
   * 打开积分商城确认弹窗。确认后 resolve，取消或关闭 reject('cancel')。
   * @param {{ title?: string, message?: string, confirmText?: string, cancelText?: string }} options
   */
  inject("xcoinsConfirm", (options = {}) => {
    return getConfirmVm(app).open(options);
  });
}
